app.config(function ($translateProvider) {
    "use strict";

    $translateProvider.translations("en-gb", {
        TERMS_OF_USE: 'Terms of Use',
        TERMS_USE_PRIVACY_POLICY: 'Terms of Use and Privacy Policy',
        TERMS_USE_PRIVACY_POLICY_CONFIRMATION: 'I confirm that I have read and accepted the Vantify<br><a href="https://vantify.com/terms-of-use" target="_blank">Terms of Use</a> and <a href="https://vantify.com/privacy-policy" target="_blank">Privacy Policy</a>.',
        DECLINE: 'Decline',
        TERMS_CONDITIONS_ACCEPTED: 'Terms of Use Accepted',
        YOU_NOT_BE_GRANTED_ACCESS_IF_YOU_DONT_ACCEPT: 'You will not be granted access to the system if you do not Accept the Vantify Terms of Use and Privacy Policy.',
        TERMS_OF_USE_ACCEPTED_AT: 'Terms of Use Accepted At',
        TERMS_OF_USE_NOT_YET_ACCEPTED: 'Not yet accepted',
        PREVIOUS_TERMS_ACCEPTED: 'Previous Terms Accepted'
    });
});
